import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4438bd74")

_pushScopeId("data-v-4438bd74")
const _hoisted_1 = { id: "visSettings" }
const _hoisted_2 = { class: "settings-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Component ID", -1)
const _hoisted_4 = { class: "settings-row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Visible", -1)
const _hoisted_6 = { class: "label" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("input", {
        type: "text",
        class: "componentIdInput",
        onFocus: _cache[1] || (_cache[1] = $event => (_ctx.idWatcher = val => (_ctx.action.targetId = val))),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.action.targetId = $event))
      }, null, 544), [
        [_vModelText, _ctx.action.targetId]
      ])
    ]),
    _createVNode("p", {
      class: ["label", _ctx.components[_ctx.action.targetId] ? '' : 'red-text']
    }, " TARGET" + _toDisplayString(!_ctx.components[_ctx.action.targetId]
          ? " NOT FOUND!"
          : ": " + _ctx.components[_ctx.action.targetId].name), 3),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.action.visibility = $event))
      }, null, 512), [
        [_vModelCheckbox, _ctx.action.visibility]
      ])
    ]),
    _createVNode("p", _hoisted_6, " Action will make component " + _toDisplayString(_ctx.action.visibility ? "visible" : "invisible"), 1)
  ]))
})